import { EfetivacaoRequisicao, EfetivacaoResposta } from "#/types";
import { request } from "#/utils/request";

/** Endpoints */
export const ENDPOINT_PROPOSTAS = "/propostas";

/**
 * @function efetivarCotacao - GET Address
 * @param dadosEfetivacao - dados para realizar a efetivacao
 */
export const efetivarCotacao = async (dadosEfetivacao: EfetivacaoRequisicao) =>
  (await request.post<EfetivacaoResposta>(ENDPOINT_PROPOSTAS, dadosEfetivacao))
    .data;
